const columns = [
  { Header: 'Client Name', accessor: 'viaje_client_name' },
  { Header: 'Cert Name', accessor: 'cert_name' },
  { Header: 'Usage count', accessor: 'usage_count' },
  { Header: 'Certificate issuer common name', accessor: 'certificate_issuer_common_name' },
  { Header: 'Cipher bits', accessor: 'cipher_bits' },
  { Header: 'Expired', accessor: 'expired' },
  { Header: 'Certificate issued at', accessor: 'certificate_issued_datetime' },
  { Header: 'Certificate expires at', accessor: 'certificate_expires_datetime' },
]

const subTableColumns = [
  { Header: 'IP Address', accessor: 'ip_address' },
  { Header: 'Port', accessor: 'port' },
  { Header: 'Transport Protocol', accessor: 'transport_protocol' },
  { Header: 'OS', accessor: 'os' },
  { Header: 'System', accessor: 'system' },
  { Header: 'Product', accessor: 'product' },
  { Header: 'Location country', accessor: 'location_country_name' },
  { Header: 'Summary', accessor: 'summary' },
  { Header: 'Cipher version', accessor: 'cipher_version' },
  { Header: 'Cipher bits', accessor: 'cipher_bits' },
  // { Header: 'Cipher name', accessor: 'cipher_name' },
  { Header: 'Certificate issuer country', accessor: 'certificate_issuer_country' },
  { Header: 'Certificate issuer common name', accessor: 'certificate_issuer_common_name' },
  { Header: 'Certificate issuer location', accessor: 'certificate_issuer_location' },
  { Header: 'Certificate issuer organization', accessor: 'certificate_issuer_organization' },
  { Header: 'Certificate subject', accessor: 'certificate_subject' },
  // { Header: 'Certificate public key type', accessor: 'certificate_public_key_type' },
  // { Header: 'Certificate public key bits', accessor: 'certificate_public_key_bits' },
  // { Header: 'Certificate signature algorithm', accessor: 'certificate_signature_algorithm' },
  { Header: 'Certificate expired', accessor: 'certificate_expired' },
  // { Header: 'Location longitude', accessor: 'location_longitude' },
  // { Header: 'Location latitude', accessor: 'location_latitude' }
]

export { columns, subTableColumns }
